import React from 'react';
import { isEmpty } from 'lodash';

import ReferrerDetails from './components/ReferrerDetails';
import EntityCardSkeleton from '../../../../components/EntityCardSkeleton';

// Loader / empty-state gate for ReferrerDetails. Chrome swapped from AntD
// Card+Row to a v2-consistent container; ReferrerDetails owns the actual
// section layout.
const Referrers = ({ chartsLoading, referrerData }) => {
  if (chartsLoading) return <EntityCardSkeleton />;

  if (isEmpty(referrerData)) return null;

  return <ReferrerDetails referrerData={referrerData} />;
};

export default Referrers;
